if ($('.desc-rating').length) {
  $('#ratingWrapper .rate-wrap').clone().appendTo('.desc-rating .left');
  $('.desc-rating .add-comment .rating-icon').attr('href','#ratingWrapper');
  $('.desc-rating .rate-star-wrap a').attr('data-toggle','scroll');
  $('.desc-rating .right').clone().insertAfter('#ratingWrapper');
  $('.desc-rating .left .link-like').replaceWith('<a href="#ratingTab" class="btn btn-default">'+translation('NapsatHodnoceni')+'</a>')
}

if ($('.basic-description .banner-slider').length) {
  $('.basic-description .banner-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    autoplay: false,
    dots: false,
    arrows: true,
    responsive: [
      {
        breakpoint:991,
        settings: {
          slidesToShow:1.5
        }
      },
      {
        breakpoint:579,
        settings: {
          slidesToShow:1.2
        }
      }
    ]
  });
}

if ($('.basic-description .reels-slider').length) {
  $('.basic-description .reels-wrap').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    autoplay: false,
    dots: false,
    arrows: true,
    responsive: [
      {
        breakpoint:1199,
        settings: {
          slidesToShow:3.5
        }
      },
      {
        breakpoint:991,
        settings: {
          slidesToShow:3 
        }
      },
      {
        breakpoint:479,
        settings: {
          slidesToShow:1.2
        }
      }
    ]
  });
}

if ($('.extended-description').length) {
  $(function () {
    var $params = $('.extended-description .detail-parameters');
    if (!$params.length) return;

    var $rows = $params.find('tbody tr');
    var limit = 8;

    if ($rows.length <= limit) return;

    $rows.slice(limit).hide();

    var $btn = $('<a class="params-toggle btn-simple">Všechny parametry</a>');
    $params.after($btn);

    $btn.on('click', function () {
      var expanded = $params.hasClass('is-open');

      if (expanded) {
        $rows.slice(limit).slideUp(200);
        $btn.text('Všechny parametry');
        $params.removeClass('is-open');
      } else {
        $rows.slice(limit).slideDown(200);
        $btn.text('Skrýt parametry');
        $params.addClass('is-open');
      }
    });
  });
}


if ($('.basic-description #katanaGallery').length) {
  $('.basic-description .katana-gallery__track').slick({
    slidesToShow: 5.7,
    slidesToScroll: 1,
    infinite: false,
    autoplay: false,
    dots: false,
    arrows: false,
    responsive: [
      {
        breakpoint:1199,
        settings: {
          slidesToShow:4.6
        }
      },
      {
        breakpoint:991,
        settings: {
          slidesToShow:4.8
        }
      },
      {
        breakpoint:479,
        
        settings: {
          slidesToShow:1.2,
          arrows: true,
        }
      }
    ]
  });

  if ($('.section-middle').length) {
    $('#tab-content #ratingTab').insertAfter('.section-middle');
    $('#footer .footer-icons').insertAfter('.section-middle');
  } else {
    $('#footer .footer-icons').insertAfter('#description');
  }
}

if ($('.basic-description .compare-slider').length) {
  $('.basic-description .compare-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: false,
    autoplay: false,
    dots: false,
    arrows: true,
    responsive: [
      {
        breakpoint:1199,
        settings: {
          slidesToShow:2 
        }
      },
      {
        breakpoint:767,
        settings: {
          slidesToShow:1
        }
      }
    ]
  });
}